// PlannerTimelineHelpMessage.js

import { Box, Typography } from "@mui/material";
import { LightbulbOutlined } from "@mui/icons-material";

export default function PlannerTimelineHelpMessage() {
  return (
    <Box
      sx={{
        mb: 2,
        p: 1.5,
        borderRadius: 2,

        bgcolor: "background.paper",

        border: "1px solid",
        borderColor: "divider",

        display: "flex",
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      <LightbulbOutlined color="warning" fontSize="small" />

      <Box>
        <Typography variant="body2" fontWeight={600}>
          Neu im Planer?
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Klicke auf eine leere Zelle in deinem Fach, um ein neues Projekt zu
          erfassen.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Klicke auf dein bestehendes Projekt, um es zu bearbeiten oder auf
          andere Projekte, um Details zu sehen.
        </Typography>
      </Box>
    </Box>
  );
}
